import React from "react";
import type { TFunction } from "i18next";
import type { ColumnsType } from "antd/es/table";

export const getDealersColumns = (
  t: TFunction,
  options: string[],
  currentPath: string,
  onCellClick: (
    record: { id?: string | number; ArchivePeriodId?: string | number },
    option: string
  ) => void,
  sortField?: string,
  sortType?: string,
  sortableColumns?: string[],
  widths?: Record<string, number>
): ColumnsType<any> =>
  options.map((option) => {
    const translationKey = `dealers.${option}`;
    const translatedTitle = t(translationKey);
    const title = translatedTitle !== translationKey ? translatedTitle : option;

    const isClickable =
      (currentPath !== "/dealers/inheritance/" && option === "DealerName") ||
      (currentPath === "/dealers/inheritance/" && option === "id");

    const isSortable = sortableColumns
      ? sortableColumns.includes(option)
      : true;

    const sortOrder =
      isSortable && sortField === option
        ? sortType === "ASC"
          ? "ascend"
          : sortType === "DESC"
          ? "descend"
          : undefined
        : undefined;

    return {
      minWidth: widths?.[option],
      title,
      dataIndex: option,
      key: option,
      sorter: isSortable,
      sortOrder: isSortable ? sortOrder : undefined,
      onCell: isClickable
        ? (record: {
            id?: string | number;
            ArchivePeriodId?: string | number;
          }) => ({
            onClick: () => onCellClick(record, option),
            style: { cursor: "pointer" },
          })
        : undefined,
    };
  });
